import React from "react";
import { useNavigate } from "react-router-dom";
import PageTitle from "../../components/PageTitle";
import { Card } from "../../components/ui/Card";
import { motion } from "framer-motion";
import { FiCreditCard, FiDollarSign, FiShoppingCart } from "react-icons/fi";

const Finance = () => {
  const navigate = useNavigate();

  const financeItems = [
    {
      title: "My Wallet",
      description: "Store money and manage your balance for future portal services.",
      icon: FiCreditCard,
      path: "/app/wallet-transaction",
      color: "bg-primary-100 text-primary-600",
    },
    {
      title: "Tuition Fees",
      description: "Conveniently pay your semester tuition fees and other academic charges.",
      icon: FiDollarSign,
      path: "/app/payment",
      color: "bg-success-100 text-success-600",
    },
    {
      title: "Other Payments",
      description: "Pay for various additional services, certifications, and items.",
      icon: FiShoppingCart,
      path: "/app/other-payments",
      color: "bg-warning-100 text-warning-600",
    },
  ];

  return (
    <div className="animate-fade-in">
      <PageTitle
        title="Financial Center"
        sub="Manage your payments, wallet, and financial records in one place."
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
        {financeItems.map((item, i) => {
          const Icon = item.icon;
          return (
            <motion.div
              key={item.path}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
            >
              <Card
                onClick={() => navigate(item.path)}
                className="group relative cursor-pointer hover:-translate-y-2 transition-all duration-300"
                padding="lg"
              >
                <div className={`w-[60px] h-[60px] rounded-2xl flex items-center justify-center mb-6 transition-all ${item.color}`}>
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="text-xl font-bold text-neutral-900 mb-2">{item.title}</h3>
                <p className="text-sm text-neutral-500 leading-relaxed m-0">{item.description}</p>
                <div className="absolute bottom-6 right-6 w-8 h-8 rounded-full bg-white border border-neutral-100 flex items-center justify-center text-neutral-400 group-hover:bg-primary-500 group-hover:text-white group-hover:translate-x-1 transition-all">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </Card>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default Finance;
